import { atom, useRecoilState } from "recoil";

import { API_FETCH_STATUS } from "constants/common";
import RestApiCall, { isRequestCancelled } from "interceptor/aeh";
import Environment from "services/environment";

const env = Environment.getEnv();

const { LOADING, ERROR, SUCCESS } = API_FETCH_STATUS;

const fetchCompletenessAPI = ({ params }) => {
    let apiPayload = {
        method: "POST",
        url: 'user/profile/fetch/completeness',
        baseURL: env.profileBaseUrl,
        data: params,
    }
    return RestApiCall.api(apiPayload);
}

const INITIAL_STATE = {
    state: null,
    profileCompleteness: {
        state: null,
        completenessCount: null
    }
};

const profileCompletenessAtom = atom({
    key: "profileCompleteness",
    default: { ...INITIAL_STATE }
});

const useProfileCompleteness = () => {
    const [profileCompletenessState, setProfileCompletenessState] = useRecoilState(profileCompletenessAtom);
    
    const { profileCompleteness } = profileCompletenessState;

    const updateStateProperties = (newState) => setProfileCompletenessState((prevState) => ({ ...prevState, ...newState }));

    const fetchProfileCompleteness = ({ partyId }) => {
        updateStateProperties({ state: LOADING })

        const params = {
            partyAccount: partyId,
        };

        return new Promise((resolve, reject) => {
            fetchCompletenessAPI({ params })
                .then((res) => {
                    if (res.data) {
                        updateStateProperties({
                            profileCompleteness: {
                                state: SUCCESS,
                                ...res.data
                            },
                        });
                        resolve(res.data);
                    } else {
                        throw new Error(res);
                    }
                })
                .catch((err) => {
                    if (!isRequestCancelled(err)) {
                        updateStateProperties({ state: ERROR });
                        reject(err);
                    }
                })
        });

    };

    return {
        profileCompleteness,
        fetchProfileCompleteness,
    }
};

export default useProfileCompleteness;